export const colors = {
  red: '#dc0d03', // ef412f
  green: '#8ec641',
  grey: '#e6e6e6',
  greyOnGrey: '#acacac',
  middleGrey: '#696969',
  darkGrey: '#32383a',
  orange: '#eba808',
  yellow: '#fff45f',
}

export const supportColors = {
  'mimořádně podporuje': '#43711a',
  'aktivně podporuje': '#5c9d3e',
  podporuje: '#92c848',
  'pro i proti': '#eba808',
  nepodporuje: '#e35d16',
  blokuje: '#dd1e22',
  nehlasuje: '#888888',
}

export const transition = 'all 0.5s ease-in-out'

export const administrationDisclaimer =
  'Toto hodnocení vychází pouze z návrhů a hlasování<br>' +
  'v Parlamentu ČR. Pro členy vlády může být zavádějící,<br>' +
  'neboť nezahrnuje jejich hlasování a aktivitu při<br>' +
  'vyjednávání ve vládě a vládní koalici.'



// WEBPACK FOOTER //
// ./constants.js